import { render, staticRenderFns } from "./PaymentOrderTable.vue?vue&type=template&id=122f6ca3"
import script from "./PaymentOrderTable.vue?vue&type=script&lang=js"
export * from "./PaymentOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports